export default __webpack_public_path__ + "static/media/Quiken_Envios_Internacionales.cf8ac4ad.png";